(function () {
  'use strict';
  var pendingKey = 'tc_inquiry_pending';
  function path() { return window.location.pathname; }
  function storageGet(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } }
  function storageSet(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  function storageRemove(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  function publish(name, data, attempt) {
    attempt = attempt || 0;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { var result = window.Shopify.analytics.publish(name, data); if (result && result.catch) result.catch(function () {}); } catch (_) {}
    } else if (attempt < 20) { setTimeout(function () { publish(name, data, attempt + 1); }, 500); }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var region = link.closest('[data-tc-placement], .shopify-section, header, footer');
    var placement = region ? (region.getAttribute('data-tc-placement') || region.id || region.tagName.toLowerCase()) : 'page';
    if (/^tel:/i.test(href)) { publish('treasured:call_click', { page_path: path(), placement: placement }); }
    else {
      var target; try { target = new URL(href, window.location.origin); } catch (_) { return; }
      if (target.origin === window.location.origin && target.pathname === '/pages/collection-inquiry') {
        publish('treasured:inquiry_click', { page_path: path(), placement: placement });
        storageSet('tc_inquiry_source', path());
      }
    }
  });
  document.addEventListener('submit', function (event) {
    if (event.target.id === 'CollectionInquiry' && event.target.checkValidity()) {
      storageSet(pendingKey, JSON.stringify({ time: Date.now(), source: storageGet('tc_inquiry_source') || path() }));
    }
  });
  function checkSuccess() {
    if (!document.querySelector('[data-tc-inquiry-success]')) return;
    var raw = storageGet(pendingKey); storageRemove(pendingKey);
    if (!raw) return;
    try {
      var pending = JSON.parse(raw);
      if (Date.now() - pending.time >= 0 && Date.now() - pending.time < 3600000) {
        publish('treasured:collection_inquiry_success', { page_path: path(), source_path: pending.source, lead_type: 'collection_inquiry' });
        storageRemove('tc_inquiry_source');
      }
    } catch (_) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkSuccess); else checkSuccess();
})();
